import LBElementImage from './LBElementImage.vue';
import LBElementLink from './LBElementLink.vue';
import LBElementSignup from './LBElementSignup.vue';
import LBElementSpace from './LBElementSpace.vue';
import LBElementText from './LBElementText.vue';
import LBElementOffer from './LBElementOffer.vue';

export const LBElements = {
	LBElementImage,
	LBElementLink,
	LBElementSignup,
	LBElementSpace,
	LBElementText,
	LBElementOffer
};
